import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, []);
  const updateProvisioningData = `updateProvisioningData(input: [${dataModify}])`;
  return gql`
  mutation {
    ${updateProvisioningData} {
      id
    }
  }
`;
};
